import { channelMeta } from "./journeyChannels";

// "META Paid (CVille, RVA)" style labels, one per channel
const channelLabels = (items) => {
  const map = {};
  for (const c of items) {
    const meta = channelMeta(c.channel);
    const entry = (map[c.channel] = map[c.channel] || { channel: c.channel, meta, locs: [] });
    const prefix = `${meta.label} - `;
    const loc = c.name.startsWith(prefix) ? c.name.slice(prefix.length).trim() : "";
    if (loc && !entry.locs.includes(loc)) entry.locs.push(loc);
  }
  return Object.values(map).map((e) => ({
    ...e,
    text: e.locs.length ? `${e.meta.label} (${e.locs.join(", ")})` : e.meta.label,
  }));
};

// One cell per month, aligned under each bar of the Brand Journey chart.
export const CampaignBadgeRow = ({ series, campaignsFor, spikeSet, selected, onSelect, padLPct, padRPct }) => (
  <div
    className="grid gap-px mt-1"
    style={{ gridTemplateColumns: `repeat(${series.length}, minmax(0, 1fr))`, paddingLeft: `${padLPct}%`, paddingRight: `${padRPct}%` }}
    data-testid="journey-campaign-badge-row"
  >
    {series.map((row) => {
      const labels = channelLabels(campaignsFor(row.month));
      const isSpike = spikeSet.has(row.month);
      const isSel = selected === row.month;
      return (
        <button
          key={row.month}
          type="button"
          onClick={() => onSelect(isSel ? null : row.month)}
          className={`flex flex-col items-center gap-0.5 rounded-md px-0.5 py-1 min-h-[28px] transition-colors hover:text-white ${
            isSel ? "ring-1 ring-lime-300/60" : isSpike ? "ring-1 ring-lime-300/25" : ""
          }`}
          data-testid={`journey-month-badges-${row.month}`}
          aria-label={`Campaigns for ${row.month}`}
        >
          {labels.length === 0 && <span className="text-slate-600 text-[9px]">-</span>}
          {labels.map((l) => (
            <span
              key={l.channel}
              className="px-0.5 text-[9px] md:text-[10px] font-medium leading-tight text-slate-300 max-w-full break-words text-center"
              data-testid={`journey-badge-${row.month}-${l.channel}`}
            >
              {l.text}
            </span>
          ))}
        </button>
      );
    })}
  </div>
);

export default CampaignBadgeRow;
